import React from "react";
import Keycloak from 'keycloak-js';
import { KEYCLOAK_SERVER, KEYCLOAK_REALM, KEYCLOAK_CLIENT_ID } from "./common/utils/apiService";

const keycloak = new Keycloak({
    realm: KEYCLOAK_REALM,
    url: `${KEYCLOAK_SERVER}`,
    clientId: KEYCLOAK_CLIENT_ID
});

export default keycloak;